import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useGetEligibleTarget } from '../../-query';
import { StartOperationPackageByEligibleTargetForm } from './-components/StartOperationPackageByEligibleTargetForm';
export const Route = createFileRoute('/_individual/individual/operation-package/$id/target/$targetId/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id,
    targetId
  } = Route.useParams();
  const navigate = Route.useNavigate();
  const {
    data: eligibleTargets
  } = useGetEligibleTarget(id);
  const selectedTarget = eligibleTargets.find(target => target.id === targetId);

  // ガード: 不正なtargetIdの場合はStep 1にリダイレクト（履歴に不正URLを残さない）。
  // targetId 依存の suspense クエリ（保持者取得）はフォーム側に閉じ込め、selectedTarget
  // 確定後にのみ発火させる。不正 targetId で BE が 404 を返しても、ここでのリダイレクトが
  // 先行するため ErrorBoundary に落ちない（DC-8806）。
  useEffect(() => {
    if (!selectedTarget) {
      navigate({
        to: `/individual/operation-package/${id}`,
        replace: true
      });
    }
  }, [selectedTarget, navigate, id]);
  if (!selectedTarget) {
    return null;
  }
  return <StartOperationPackageByEligibleTargetForm id={id} targetId={targetId} selectedTarget={selectedTarget} />;
}